<template>
  <breadCrumbs title="Product" main="Ecommerce" title1="Product" />

  <topPage />
</template>

<script>
import topPage from './toppage.vue'

export default {
  name: 'indexProduct',
  components: {
    topPage
  }
}
</script>
